// dependencies
import PropTypes from "prop-types";
import React from "react";

// utils
import Serialize from "../../../react/utils/SerializeObject";

// styles
import css from "./Office365Button.module.scss";

type Office365ButtonProps = {
	queryParameters: Record<string, string>;
};

const Office365Button = ({ queryParameters = {} }: Office365ButtonProps) => {
	const query = Serialize(queryParameters);

	return (
		<a href={`/login/microsoft-oauth/?${query}`} className={`${css.main}`} aria-label="Sign in with Office365">
			<div className={css.iconWrapper}>
				<img alt="" src="https://talent.performyard.com/static/img/front/microsoft/office-365.png" />
			</div>
			<div className={css.label}>Sign in with Office365</div>
		</a>
	);
};

export default Office365Button;
